import {PageableModel} from "../../common/models/table";
import {AxiosResponse} from "axios";
import {Api, apiUrls} from "../../helpers/api";
import {SeaFerriesSummaryModel, SeaFerriesSummaryFilters} from "../models/seaFerriesSummary";
import http from "../../common/services/httpService";
import {ReportFileFormat} from "../models/reportFileFormatEnum";
import {DownloadService} from "../../common/services/downloadService";

export class SeaFerriesSummaryService {
    private static baseUrl = apiUrls.reports.seaFerriesSummary;

    public static async generateReport(filters: SeaFerriesSummaryFilters): Promise<AxiosResponse<PageableModel<SeaFerriesSummaryModel>>> {
        const url = Api.getUrl(this.baseUrl);

        return await http.get<PageableModel<SeaFerriesSummaryModel>>(
            `${Api.addParams(url, this.getParams(filters))}`
        );
    }

    public static async download(filters: SeaFerriesSummaryFilters, fileFormat: ReportFileFormat): Promise<AxiosResponse> {
        const mediaType = fileFormat === ReportFileFormat.xls ? "application/xls" : "application/csv";

        return DownloadService.download(this.baseUrl, mediaType, this.getParams(filters));
    }

    private static getParams(filters: SeaFerriesSummaryFilters) {
        return `year=${filters.year}&month=${filters.month}`;
    }
}
